export default __webpack_public_path__ + "static/media/restaurant.59ddc5dd.svg";